import { YuLifeLocale } from "hooks";
import { color } from "@styles";
import { ReactElement } from "react";

type Data = Record<
  "uk" | "us" | "za",
  { bulletFontColour: string; logos: { width: number; src: string; alt: string }[] }
>;

const data: Data = {
  uk: {
    bulletFontColour: color.B1100,
    logos: [
      {
        width: 105,
        src: "/static/img/get-a-quote/logos/Paramount.svg",
        alt: "Paramount logo",
      },
      {
        width: 94,
        src: "/static/img/get-a-quote/logos/Curve.svg",
        alt: "Curve logo",
      },
      {
        width: 87,
        src: "/static/img/get-a-quote/logos/Sodexo.svg",
        alt: "Sodexo logo",
      },
      {
        width: 108,
        src: "/static/img/get-a-quote/logos/What3Words.svg",
        alt: "What3Words logo",
      },
    ],
  },
  us: {
    bulletFontColour: color.B1100,
    logos: [
      {
        width: 109.5,
        src: "/static/companies/companies-bar-colour/havas.svg",
        alt: "Havas logo",
      },
      {
        width: 110.5,
        src: "/static/companies/companies-bar-colour/capitalone.svg",
        alt: "CapitalOne logo",
      },
      {
        width: 53,
        src: "/static/companies/companies-bar-colour/delmonte.svg",
        alt: "Del Monte logo",
      },
      {
        width: 131,
        src: "/static/img/get-a-quote/logos/What3Words.svg",
        alt: "What3Words logo",
      },
    ],
  },
  za: {
    bulletFontColour: "",
    logos: [],
  },
};

export default data;
